/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Status_NewInputs */

const vi_cdo_status_new = /** @type {(inputs: Cdo_Status_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mới`)
};

/**

* @param {Cdo_Status_NewInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_status_new = /** @type {((inputs?: Cdo_Status_NewInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Status_NewInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_status_new(inputs)
});